<template>
  <main>
    <vue-headful
      title="ADLCJ リヨン補習授業校 - Cours de japonais à Lyon"
      description="日本の学習指導要領に準拠した、国語の補習授業を行なっています。ADLCJ gére l’école complémentaire pour l’enseignement du japonais à Lyon, et propose également des cours de japonais pour adultes."
      url="https://adlcj.fr/"
      type="website"
      image="https://adlcj.fr/img/kingyo_home.95817585.svg"
      site_name="ADLCJ : Association pour le Développement de la Langue et de la Culture Japonaises"
    />
    <HomeFR v-if="$i18n.locale === 'fr'" />
    <HomeJA v-else />

  </main>
</template>

<script>
import HomeJA from "../components/HomeJA.vue";
import HomeFR from "../components/HomeFR.vue";

export default {
  name: "Home",
  components: { HomeJA, HomeFR },
};
</script>

<style lang="scss">

</style>